import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { MdEdit } from 'react-icons/md';
import {FaRegTrashAlt} from "react-icons/fa";
import {doc, getDoc, updateDoc} from "firebase/firestore";
import {db} from "../../../components/Firebase/Firebase";

const DistanceItem = ({ distance, eventId, onDistancesUpdated }) => {
    const navigate = useNavigate();

    const handleDelete = async () => {
        const confirm = window.confirm(`Вы уверены, что хотите удалить дистанцию "${distance.title}"?`);
        if (!confirm) return;

        try {
            const docRef = doc(db, "events", eventId);
            const docSnap = await getDoc(docRef);
            if (!docSnap.exists()) return;

            const data = docSnap.data();
            const updatedDistances = (data.distances || []).filter(
                d => d.id !== distance.id
            );

            await updateDoc(docRef, { distances: updatedDistances });

            console.log("Дистанция удалена:", distance.title);
            onDistancesUpdated();
        } catch (err) {
            console.error("Ошибка при удалении дистанции:", err);
        }
    };

    const handleEdit = () => {
        navigate(`/events/${eventId}/distances/${distance.id}`, {
            state: { distance }
        });
    };

    return (
        <tr>
            <td>{distance.title}</td>
            <td>{distance.distance}</td>
            <td>{distance.elevationGain ?? '-'}</td>
            <td>{distance.itraPoints ?? '-'}</td>
            <td>{distance.isEnabled ? '✅' : '❌'}</td>
            <td className='actions'>
                <div className='actions d-flex align-items-center'>
                    <Button className='success' color="success" onClick={handleEdit}><MdEdit/></Button>
                    <Button className='error' color="error" onClick={handleDelete}><FaRegTrashAlt/></Button>
                </div>
            </td>
        </tr>
    );
};

export default DistanceItem;
